import { Box, makeStyles } from '@material-ui/core'
import React from 'react'
import { MainContainer } from '../../atoms'

const useStyles = makeStyles((theme) => ({
    wrapper: {
        margin: '3% 0%',
        padding: '0 5%',
        fontSize: '18px',
        fontFamily: theme.typography.fontFamily,
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
            padding: '0 8%',
        },
    },
    link: {
        color: '#182AC3',
        textDecoration: 'underline',
        fontWeight: 600,
        cursor: 'pointer',
    },
    description: {
        color: '#d93025',
        fontFamily: 'inherit',
    },
}))

export function EndOfSupportNotice({ linkText = 'End of Support', description, href }) {
    const classes = useStyles()
    return (
        <MainContainer>
            <Box className={classes.wrapper}>
                
                <a    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.link}
                >
                    {linkText}
                </a>
                <span className={classes.description}> {description}</span>
            </Box>
        </MainContainer>
    )
}